import { Bfp } from "../../Bfp";

interface BfpFormatterProps {
  value: number | null | undefined;
}

export const BfpFormatter = ({ value }: BfpFormatterProps) => (
  <Bfp fullWidth value={value} />
);
